import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

/** Formats integer cents as a display string, e.g. 125000 -> "$1,250.00". */
export function formatCents(cents: number) {
  return currencyFormatter.format(cents / 100);
}

/** Parses a dollars-string form field (e.g. "125.5") into integer cents, e.g. -> 12550. */
export function dollarsToCents(value: string): number {
  return Math.round(parseFloat(value || "0") * 100);
}

/** Converts integer cents into a plain dollars string for a form field, e.g. 12550 -> "125.50". */
export function centsToDollars(cents: number): string {
  return (cents / 100).toFixed(2);
}

/** Turn a data URL (e.g. a drawn signature's PNG) into a File for upload. */
export function dataUrlToFile(dataUrl: string, filename: string): File {
  const [meta = "", base64 = ""] = dataUrl.split(",");
  const mime = meta.match(/:(.*?);/)?.[1] ?? "image/png";
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new File([bytes], filename, { type: mime });
}
